import { create } from "zustand";

export const useToastStore = create((set) => ({
  open: false,
  message: "",
  severity: "info", // 'success' | 'info' | 'warning' | 'error'
  autoHideDuration: 3000,
  showToast: (severity = "info", message = "Ceci est une notification", autoHideDuration = 3000) =>
    set({ open: true, message, severity, autoHideDuration }),
  hideToast: (event, reason) => {
    if (reason === "clickaway") return;
    set({ open: false });
  },
}));
